import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const phoneExtensionFormatValidator: ValidatorFn = (control: AbstractControl):
  ValidationErrors | null => {
  let invalid: boolean = false;

  if (!control.value) {
    return null;
  }

  if (control.value !== "" && !control.value.toString().trim().match(/^[0-9]{1,4}$/)) {
    invalid = true;
  }

  return invalid ? { invalidExtension: true } : null;
}

export const phoneFormatValidator: ValidatorFn = (control: AbstractControl):
  ValidationErrors | null => {
  let invalid: boolean = false;

  if (!control.value) {
    return null;
  }

  if (control.value !== "" && !control.value.toString().trim().match(/^(\+?\d{1,2}\s)?\(?\d{3}\)?[\s-]?\d{3}[\s-]?\d{4}$/)) {
    invalid = true;
  }

  return invalid ? { invalidPhone: true } : null;
}

